import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap'
import {getSurveyEntry, putFormValues} from '../../../../gateways/surveys';
import SurveyViewComponent from '../../../../components/SurveyView';

class SurveyView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className={"modal-xl" + this.props.className}>
        <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
        <ModalBody>
          <SurveyViewComponent
              id={this.props.id}
              getData={getSurveyEntry}
              putData={putFormValues}
              editAble={false} />
        </ModalBody>
      </Modal>
    );
  }
}

SurveyView.defaultProps = {
  toggle: () => {},
  isOpen: false,
  className: "",
  id: null,
  title: ""
};

export default SurveyView;


// WEBPACK FOOTER //
// ./src/views/Surveys/View/modals/SurveyView.js